import AboutNex from 'views/AboutNex'

export default AboutNex